import React, {useContext, useEffect, useState} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import RegistroPdfFormPartial from '../components/partials/RegistroPdfFormPartial';

const RegistroPdfForm = () => {
  const navigate = useNavigate();
  const [authInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)

  let { id } = useParams();

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true && authInformation.rol === 'Admin' ){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  return (
    <div>
      {renderHTML && (
        <RegistroPdfFormPartial id={id} esModal={false} />
      )}
    </div>
  );
};
export default RegistroPdfForm;